import * as _anim_ from "@Elementos/Animaciones";
import * as _f_ from "@Funciones/funciones";
import { useEffect, useState } from "react";

export const Boton = ({
  texto = "Botón",
  imagen = null,
  className = "",
  children,
  procesando = false,
  estilos = {},
  tipo,
  ...props
}) => {
  const propsValidos = Object.fromEntries(
    Object.entries(props).filter(([clave, valor]) => clave !== "undefined" && valor !== undefined),
  );
  return (
    <button
      className="btn"
      tipo={tipo}
      {...propsValidos}
      style={_f_.estilosObjetoVariablesCSS(estilos)}
      // disabled={procesando}
    >
      {/* {children ? children : texto} */}
      {procesando ? <_anim_.SpinnerHTML /> : imagen !== null ? <img src={imagen} alt="Icono" /> : texto}
    </button>
  );
};
